/**
 * 全局认证状态管理
 * 用于在非 React 组件中（如请求拦截器）更新全局状态
 */

type SetInitialStateFn = (updater: (s: any) => any) => void;

let setInitialStateFn: SetInitialStateFn | null = null;

/**
 * 注册 setInitialState 函数（在 app.tsx 中调用）
 */
export function registerSetInitialState(fn: SetInitialStateFn) {
  setInitialStateFn = fn;
}

/**
 * 清除当前用户（401 时调用）
 */
export function clearCurrentUser() {
  if (setInitialStateFn) {
    setInitialStateFn((s) => ({ ...s, currentUser: undefined }));
  }
}
